export default "__VITE_ASSET__h17$aqIA__"